module.exports = "/_next/static/images/bws-logo-d6ce435fc10bd25af1b2da0c21fef480.svg";